// src/pages/Produtos/profiles/materiaPrima.js
export const materiaPrimaProfile = {
    id: 'materia-prima',
    labelForm: 'Gestão de Matéria-Prima',
    tabs: {
        cabecalho: { enabled: true },
        industria: { enabled: true },
        materiaPrima: { enabled: true },
        modoProducao: { enabled: false },
        embalagens: { enabled: true },
        caracteristicas: { enabled: true },
        bens: { enabled: false },
        mobilia: { enabled: false },
        imagens: { enabled: true },
    },

    parametros: {
        defaultsProduto: {
            materiaPrima: true,
            venda: false, // se não vende MP direto
        },
        sanitize: {
            keepChildren: ['Empresa', 'NCM', 'Fabricante', 'produtoEmbalagens', 'produtoImagens'],
        },
    },
};
